const initialize = () => {
    $('.accordion-title').click(function(e){
        e.preventDefault();
        let itemActive = $(this).parent().hasClass('active');
        if (itemActive) {
            $(this).parent().removeClass('active');
            $(this).parent().find('.accordion-content').slideUp(250);
        } else {
            $(this).parent().addClass('active');
            $(this).parent().find('.accordion-content').slideDown(250);
        }
    });
};

export default {
    initialize,
};